module.exports = __webpack_public_path__ + "static/media/businessCard.81e43bd9.svg";